import React from 'react';
import { createUseStyles } from 'react-jss';

const someMethod1 = (
  /** @type {import('./types').IconData["svgChildrenConfigs"]} */ svgChildrenConfigs,
  color,
  hoverColor
) => {
  /** @type {{ [k:string]:React.CSSProperties; }} */
  const obj = {};
  for (const svgChildConfig of svgChildrenConfigs) {
    if (color)
      obj['& ' + svgChildConfig.selector] = {
        fill: svgChildConfig.fill ? color : undefined,
        stroke: svgChildConfig.stroke ? color : undefined
      };
    if (hoverColor)
      obj['&:hover ' + svgChildConfig.selector] = {
        fill: svgChildConfig.fill ? hoverColor : undefined,
        stroke: svgChildConfig.stroke ? hoverColor : undefined
      };
  }
  return obj;
};

const useStyles = createUseStyles({
  '@keyframes slideRight': {
    to: { backgroundPosition: '1250% 0, 0 0' }
  },
  root: ({
    width,
    height,
    color,
    svgChildrenConfigs,
    opacity,
    hoverColor
  }) => ({
    width,
    height,
    opacity,
    ...someMethod1(svgChildrenConfigs, color, hoverColor),
    '&:empty': {
      background: `linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 100%
      ),
      #d7d7d7`,
      backgroundRepeat: 'repeat-y',
      backgroundSize: '90% 100%',
      backgroundPosition: '-1250% 0, 0 0',
      animation: '$slideRight 1s infinite'
    }
  })
});
export default useStyles;
